
export default {
  state: {
    subscribes: [
      {
        id: "21ffc672-02ca-411b-b210-97351f996512",
        title: "БАЛАНС",
        image: '/img/subscribes/balance.jpg',
        description: `<p class="desktop-description">Сбалансированное меню на неделю для стройности, здоровья и энергии. Отличается низкоуглеводным ужином. Разработано с учётом баланса Белки 20-30% Жиры 40-50% Углеводы 30-40%</p>
        <p class="mobile-description">Сбалансированное меню на неделю для стройности, здоровья и энергии. Отличается низкоуглеводным ужином</p>
        <p class="mobile-description">Разработано с учётом баланса Белки 20-30% Жиры 40-50% Углеводы 30-40%</p>`,
        short_description: '',
        // tags: ['Женщины', 'Мужчины', 'Дети от 6 лет'],
        notForSale: true,
        buttonLinks: [
          {
            name: 'Что выбрать?',
            link: 'https://drive.google.com/drive/folders/16b7g4l_1PxkKwzQjmHen1QzOsrZ_JNvK',
            mustBeBought: true,
          },
          {
            name: 'О балансе',
            link: 'https://online-kitchen.ru/balance_site',
            mustBeNoBought: true,
          }
        ],
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Мясо, птица, рыба и яйца',
              'Продукты с глютеном 1 раз в неделю или реже',
              'Молочные продукты в умеренном количестве, в рецептах указаны замены',
              'Коровье молоко заменяется растительным',
            ]
          },
          {
            title: 'ПОМОЖЕТ ВАМ:',
            list: [
              'Вкусно и разнообразно питаться без срывов',
              'Не думать, что купить и приготовить',
              'Сбросить вес без диет',
              'Сохранить здоровье и молодость всей семьи ',
            ]
          }
        ]
      },
      {
        id: "ede8dfc0-6ef9-443b-bbf1-28aa6f67649b",
        title: "ПРОБНОЕ МЕНЮ",
        free: true,
        nohide: true,
        // tags: ['Женщины', 'Мужчины', 'Дети от 3х лет'],
        image: '/img/subscribes/trial.jpg',
        description: 'Пробная неделя регулярного меню БАЛАНС. Доступна <span style="color: #F68C1E">БЕСПЛАТНО</span> 7 дней с момента регистрации',
        // short_description: `
        //   <div class="spec">
        //     <p class="subscribe__short-text--title white-text">СПЕЦИАЛЬНОЕ ПРЕДЛОЖЕНИЕ</p>
        //     <p class="subscribe__short-text--default white-text">Предложение действует 24 часа после регистрации</p>
        //     <p class="subscribe__short-text--default white-text">При покупке подписки на Меню Баланс сроком на один год вы получите Семейное меню и Десерты в подарок!</p>
        //   </div>
        // `,
      }
    ],
    sets: [
      {
        id: "c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78",
        title: "ДЕСЕРТЫ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/deserts',
        image: '/img/subscribes/desert.jpg',
        description: `Сборник рецептов десертов, которые можно!`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Без сахара',
              'Без глютена',
              'Без молока и молочных продуктов 90% рецептов',
              'Молочные продукты в минимальном количестве 10 % рецептов',
            ]
          }
        ]
      },
      {
        id: "e8bc1576-fdf5-494d-a90f-c31a43b8a21f",
        title: "МЕНЮ ДЛЯ ВСЕЙ СЕМЬИ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/deti',
        image: '/img/subscribes/family.jpg',
        description: `Сборник рецептов вкусных и полезных блюд, которые понравятся вашему ребёнку и всей семье. Отличается вкусными и полезными перекусами, которые удобно взять с собой`,
        // tags: ['Женщины', 'Мужчины', 'Дети от 6 лет'],
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Мясо, птица, рыба и яйца',
              'Молочные продукты в умеренном количестве',
              'Коровье молоко заменяется растительным',
              'Без глютена',
              'Без сахара',
            ]
          },
          {
            title: 'ПОМОЖЕТ ВАМ:',
            list: [
              'Экономить время на планировании рациона и покупках',
              'Вкусно и разнообразно питаться детям и всей семье',
              'Поддерживать здоровье'
            ]
          }
        ]
        // short_description:
        // <p class="subscribe__short-text--title">Специальное предложение</p>
        // <p class="subscribe__short-text--default">
        //   Купите регулярное меню INTEGRA PNS со скидкой 15% в течение 24 часов с момента регистрации. Промокод на скидку <span class="subscribe__short-text--promo">INTEGRA15</span>
        // </p>
        // <p class="subscribe__short-text--default">Бессрочный промокод на скидку 10% <span class="subscribe__short-text--promo">INTEGRA10</span></p>
        // <p class="subscribe__short-text--warning">Чтобы разблокировать меню, введите код доступа.</p>
      },
      {
        id: "1f9e97c4-5d42-4307-ac1c-daa360a047f0",
        title: "ХЛЕБ И ХЛЕБЦЫ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/hleb',
        // buttonLinks: [
        //   {
        //     name: 'Видеорецепты',
        //     link: 'https://drive.google.com/drive/folders/11ZyH7IXS0tyRcvkloK0pmzy39jPzaP4I',
        //     mustBeBought: true,
        //   },
        // ],
        image: '/img/subscribes/bread.jpg',
        description: `<p class="desktop-description">Сборник рецептов хлеба, булочек и хлебцев без глютена и дрожжей. Если вы хотите правильно питаться, но не можете отказаться от хлеба, этот сборник рецептов для вас</p>
        <p class="mobile-description">Сборник рецептов хлеба, булочек и хлебцев без глютена и дрожжей</p>
        <p class="mobile-description">Если вы хотите правильно питаться, но не можете отказаться от хлеба, этот сборник рецептов для вас</p>`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Без глютена',
              'Без дрожжей',
              'Без молока',
              'Без сахара',
            ]
          }
        ]
      },
      {
        id: '5a9e0d11-c055-44cc-b176-db2f61eab0b6',
        title: 'КУЛИЧИ И ПАСХА',
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/pasha',
        buttonLinks: [
          {
            name: 'Скачать в PDF',
            link: 'https://drive.google.com/drive/folders/1AdOf4fPoTqm_hBJcFYLXulunCQROw5gQ?usp=sharing',
            // link: 'https://drive.google.com/drive/folders/1-L6PSjwBCQtgz_IBQlLFSEJbjpR4zzNe',
            mustBeBought: true,
          },
        ],
        image: '/img/subscribes/pasha.jpg',
        description: `<p class="desktop-description">Специальное меню к празднику Православной Пасхи.</p>
        <p class="mobile-description">Специальное меню к празднику Православной Пасхи.</p>`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'Мы подготовили:',
            list: [
              'Классические рецепты куличей на дрожжевом тесте и пшеничной муке',
              'Рецепты куличей без глютена, дрожжей и молочных продуктов',
              'Рецепты творожной пасхи',
            ]
          }
        ]
      },
      {
        id: "997b2e8f-13ba-4622-8f4f-b6f3e060083b",
        title: "ПРАЗДНИЧНОЕ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/prazdnik_site',
        image: '/img/subscribes/holiday.jpg',
        description: `<p class="desktop-description">Специальное меню праздничных рецептов, которые легко готовить и вкусно есть. Купите продукты и без труда приготовите понравившиеся блюда.</p>
        <p class="mobile-description">Специальное меню праздничных рецептов, которые легко готовить и вкусно есть.</p>
        <p class="mobile-description">Вы сэкономите время и деньги. Быстро купите продукты и без труда приготовите понравившиеся блюда.</p>`,
        short_description: '<p class="subscribe__short-text--normal">Порадуйте близких вкусным и полезным праздничным ужином!</p>',
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'В МИНИМАЛЬНЫХ КОЛИЧЕСТВАХ ИСПОЛЬЗУЮТСЯ:',
            list: [
              'Молочные продукты',
              'Продукты с глютеном',
              'Сахар и мед',
            ]
          }
        ]
      },
      {
        id: "c7bf941e-7dac-4a41-9a2b-245870f7587a",
        title: "ФЕРМЕНТИРОВАННЫЕ БЛЮДА И НАПИТКИ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/kvasim',
        buttonLinks: [
          {
            name: 'Скачать в PDF',
            link: 'https://drive.google.com/drive/folders/1KZC2XjIW7vr7IsrVlT9eYDLlgYuBEML8',
          },
        ],
        image: '/img/subscribes/kvasim.jpg',
        description: `Рецепты ферментированных блюд и напитков для здоровья кишечника, иммунитета и всего организма`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
      },
      {
        id: "0d95ba19-64c2-4210-93c6-fa6c19e73ac1",
        title: "INTEGRA PNS",
        recipeSetTypes: ['partner'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/integra',
        image: '/img/subscribes/integra.jpg',
        description: `<p class="desktop-description">Базовый профилактический рацион по системе питания INTEGRA PNS для проекта Biohacking_ev. <br> Отличается низкоуглеводным завтраком и ужином </p>
        <p class="mobile-description">Базовый профилактический рацион по системе питания INTEGRA PNS для проекта Biohacking_ev.<p/>
        <p class="mobile-description">Отличается низкоуглеводным завтраком и ужином<p/>`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'В рецептах:',
            list: [
              'Не используются продукты с глютеном',
              'Молочные продукты в умеренном количестве',
              'Коровье молоко заменяется растительным',
              'Помечены продукты, содержащие лектины и оксалаты',
            ]
          },
          {
            title: 'поможет вам:',
            list: [
              'Сохранить здоровье и молодость',
              'Вкусно и разнообразно питаться',
              'Оставаться в отличной форме'
            ]
          }
        ]
      },
      {
        id: "0d657f95-f393-42b3-8e6d-eea2c02322a5",
        title: "БОУЛЫ",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/boul',
        buttonLinks: [
          {
            name: 'Конструктор',
            link: 'https://drive.google.com/drive/folders/1shu1qhahTisd9dBIlgHQyJAE_aIIKDkW',
          },
        ],
        image: '/img/subscribes/boul.jpg',
        description: `Сборник рецептов вкусных и полезных Боулов. Выбирайте готовые рецепты или соберите свой любимый Боул при мощи нашего конструктора`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Мясо, птица, рыба и яйца',
              'Разнообразные овощи',
              'Без цельного молока, глютена и сахара',
            ]
          },
          {
            title: 'ПОМОЖЕТ ВАМ:',
            list: [
              'Экономить время. Готовить боулы просто и быстро',
              'Разнообразить рацион простыми, вкусными и полезными блюдами',
            ]
          }
        ]
      },
      {
        id: "a56a6ec7-11fe-4537-8e22-6b74d27b0580",
        title: "Вегетарианское меню",
        recipeSetTypes: ['special'],
        lock: true,
        buyLink: 'https://online-kitchen.ru/vegan',
        image: '/img/subscribes/vegan.jpg',
        description: `Сборник рецептов вкусных и полезных блюд без мяса и рыбы`,
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'Рецепты с зеленым знаком Vegan:',
            list: [
              'Без мяса, рыбы и морепродуктов',
              'Без глютена',
              'Без сахара',
              'Без цельного молока',
            ]
          },
          {
            title: 'Рецепты с желтым знаком Vegan:',
            list: [
              'Без мяса, рыбы и морепродуктов',
              'Без глютена',
              'Без сахара',
              'С молочными продуктами, которые можно убрать или заменить',
            ]
          },
          {
            title: 'Рецепты без знака Vegan содержат в составе:',
            list: [
              'Яйца или Молочные продукты, которые нельзя заменить',
            ]
          },
          {
            title: 'ПОМОЖЕТ ВАМ:',
            list: [
              'Экономить время на планировании рациона',
              'Разнообразно питаться при выборе веганского и вегетарианского типа питания',
            ]
          }
        ]
      },
      {
        id: "b517544a-bcfe-4652-b06f-a4576afb8394",
        title: "ПРОБНОЕ МЕНЮ ДЛЯ ВСЕЙ СЕМЬИ",
        recipeSetTypes: ['special'],
        free: true,
        // buyLink: 'https://online-kitchen.ru/deti',
        image: '/img/subscribes/family.jpg',
        description: `Это пробная версия сборника рецептов вкусных и полезных блюд, которые понравятся вашему ребёнку и всей семье. <span style="color: #F68C1E">Чтобы получить полную версию, нажмите КУПИТЬ</span>`,
        // tags: ['Женщины', 'Мужчины', 'Дети от 6 лет'],
        footer: '<p class="mobile-description-warning">Специальное меню без срока действия после покупки</p>',
        lists: [
          {
            title: 'СОСТАВ ИНГРЕДИЕНТОВ:',
            list: [
              'Мясо, птица, рыба и яйца',
              'Молочные продукты в умеренном количестве',
              'Коровье молоко заменяется растительным',
              'Без глютена',
              'Без сахара',
            ]
          },
          {
            title: 'ПОМОЖЕТ ВАМ:',
            list: [
              'Экономить время на планировании рациона и покупках',
              'Вкусно и разнообразно питаться детям и всей семье',
              'Поддерживать здоровье'
            ]
          }
        ],
      },
    ]
  },
  getters: {
    getSubscribesAndSets(state) {
      return state.subscribes.concat(state.sets)
    },
    getRecipeSets(state) {
      return state.sets;
    },
  }
}
